export enum SignatureEditorTab {
	DRAW = 'draw',
	TYPE = 'type',
	UPLOAD = 'upload',
}
